const getSessionMiniature = (
  thumbnails: Array<{ width: number; link: string }> | undefined,
  minWidth: number,
): string => {
  if (!thumbnails?.length) return '';
  const sorted = [...thumbnails].sort((a, b) => a.width - b.width);
  let chosenThumbnail = '';
  for (const item of sorted) {
    if (item.width > minWidth) break;
    chosenThumbnail = item.link;
  }
  return chosenThumbnail || sorted[sorted.length - 1]?.link || '';
};

export default getSessionMiniature;
